import { render } from "./DjosNpt.vue?vue&type=template&id=a398e046&scoped=true"
import script from "./DjosNpt.vue?vue&type=script&lang=js"
export * from "./DjosNpt.vue?vue&type=script&lang=js"

import "./DjosNpt.vue?vue&type=style&index=0&id=a398e046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a398e046"]])

export default __exports__